
import { ServiceOverviewSection } from "@/components/services/ServiceOverviewSection";
import { BenefitsCheckList } from "@/components/services/BenefitsCheckList";
import { wisdomToothData } from "./wisdomToothData";

export const WisdomToothOverview = () => {
  return (
    <ServiceOverviewSection
      title="Expert Wisdom Tooth Extraction"
      description={
        <>
          <p className="mb-4">
            At Asrani Dental in Sadar, Nagpur, we specialize in comfortable, efficient wisdom tooth removal to relieve pain and prevent future dental problems.
          </p>
          <BenefitsCheckList benefits={wisdomToothData.benefits} />
        </>
      }
      imageSrc="/lovable-uploads/7b821ae3-8420-4b12-b60d-6b0acd29f9fb.png"
      imageAlt="Wisdom Tooth Removal at Asrani Dental Clinic, Sadar, Nagpur"
    />
  );
};
